import React, { Component, Fragment } from "react";
import firebase from "firebase";
import {
    Segment,
    Message,
    Accordion,
    Header,
    Icon,
    Image,
    List,
    Button,
    Modal,
    Input,
    Item
} from "semantic-ui-react";

class AddMemberGroup extends Component {
    state = {
        activeIndex: 0,
        currentGroup: this.props.currentGroup,
        currentUser: this.props.currentUser,
        isDM: this.props.isDM,
        leaders: this.props.leaders,
        showMemberModal: false,
        searching: false,
        loading: false,
        searchInput: "",
        usernameRef: firebase.database().ref("usernames"),
        usersRef: firebase.database().ref("users"),
        groupsRef: firebase.database().ref("groups"),
        users: [],
        searchResults: []
    };

    setActiveIndex = (e, titleProps) => {
        const { index } = titleProps;
        const { activeIndex } = this.state;
        const newIndex = activeIndex === index ? -1 : index;
        this.setState({ activeIndex: newIndex });
    };

    getCurrentGroupName = (currentGroup, isDM) => {
        return currentGroup
            ? `${isDM ? "@" : "#"} ${currentGroup.name}`
            : "Loading...";
    };

    openMemberModal = () => {
        this.setState({
            showMemberModal: true
        });
    };

    closeMemberModal = () => {
        this.setState({
            showMemberModal: false
        });
    };

    handleSearchChange = e => {
        this.setState({ searching: true, searchInput: e.target.value }, () => {
            this.searchUsername();
        });
    };

    searchUsername = () => {
        const { searchInput, currentUser, currentGroup } = this.state;
        const users = [...this.state.users];
        const regex = new RegExp(searchInput, "gi");

        const searchResults = users.reduce((acc, u) => {
            if (
                u.username.match(regex) &&
                u.uid !== currentUser.uid &&
                !Object.keys(currentGroup.members).includes(u.uid)
            ) {
                acc.push(u);
            }
            return acc;
        }, []);
        this.setState({ searchResults });
        setTimeout(() => this.setState({ searching: false }), 300);
    };

    displayPostLeaders = leaders =>
        Object.entries(leaders)
            .sort((a, b) => b[1].count - a[1].count)
            .map(
                ([username, user], index) =>
                    index <= 3 && (
                        <List.Item key={index} style={{margin: "1em"}}>
                            <Image avatar src={user.avatar} />
                            <List.Content>
                                <List.Header style={{ color: "black" }}>
                                    {username}
                                </List.Header>
                                <List.Description
                                    style={{ color: "black" }}
                                >
                                    {user.count} posts
                                </List.Description>
                            </List.Content>
                        </List.Item>
                    )
            );

    displaySearchResults = searchResults => {
        const { loading } = this.state;
        return (
            <React.Fragment>



            <Item.Group>
                {searchResults.map((u, index) => (
                    <Item key={index}> 
                        <Item.Image size="mini" src={u.avatar} />
                        <Item.Content verticalAlign="middle">
                            <Item.Header>{u.username}</Item.Header>
                            <Button
                                inverted
                                floated="right"
                                color="green"
                                size="mini"
                                loading={loading}
                                disabled={loading}
                                onClick={() => this.addMember(u)}
                            >
                                Add Member
                            </Button>
                        </Item.Content>
                    </Item>
                ))}
            </Item.Group>
            </React.Fragment>
        );
    };

    addMember = user => {
        this.setState({ loading: true });
        const { currentGroup, groupsRef, usersRef } = this.state;
        console.log(user);
        console.log(currentGroup);
        usersRef
            .child(user.uid)
            .child("groups")
            .child(currentGroup.id)
            .set({
                groupId: currentGroup.id,
                isMember: true
            })
            .then(() => {
                groupsRef
                    .child(currentGroup.id)
                    .child("members")
                    .child(user.uid)
                    .set({
                        username: user.username
                    });
            })
            .then(() => {
                this.setState({ loading: false });
                this.closeMemberModal();
            });
    };

    addUsernameListener = () => {
        let users = [];
        const { usernameRef } = this.state;

        usernameRef.on("child_added", snap => {
            users.push(snap.val());
            this.setState({ users, loadng: false });
        });
    };

    removeUsernameListener = () => {
        const { usernameRef } = this.state;
        usernameRef.off();
    };

    /**
     * Lifecycle Methods
     */
    static getDerivedStateFromProps(nextProps) {
        return {
            currentGroup: nextProps.currentGroup,
            currentUser: nextProps.currentUser,
            isDM: nextProps.isDM,
            leaders: nextProps.leaders
        };
    }

    componentDidMount() {
        this.addUsernameListener();
    }

    componentWillUnmount() {
        this.removeUsernameListener();
    }

    render() {
        const {
            activeIndex,
            currentGroup,
            isDM,
            leaders,
            showMemberModal,
            searching,
            searchInput,
            searchResults
        } = this.state;
        return (
            <Fragment>
                {/* <Segment
                    loading={!currentGroup}
                    style={{
                        textAlign: "center",
                        background: "transparent",
                        border: "1px solid black"
                    }}
                >
                    <Header
                        as="h3"
                        attached="top"
                        style={{
                            background: "transparent",
                            border: "1px solid transparent",
                            color: "black",
                            padding: "0em"
                        }}
                    >
                        {this.getCurrentGroupName(currentGroup, isDM)}
                    </Header>
                    <Accordion
                        styled
                        style={{
                            background: "transparent",
                            border: "1px solid rgb(95, 117, 137)",
                            color: "snow"
                        }}
                    >
                        <Accordion.Title
                            index={0}
                            active={activeIndex === 0}
                            onClick={this.setActiveIndex}
                            style={{ color: "gainsboro" }}
                        >
                            <Icon name="info" />
                            Details <Icon name="dropdown" />
                        </Accordion.Title>
                        <Accordion.Content
                            active={activeIndex === 0}
                            style={{ overflowWrap: "break-word" }}
                        >
                            {currentGroup && currentGroup.details}
                        </Accordion.Content>
                        <Accordion.Title
                            index={1}
                            active={activeIndex === 1}
                            onClick={this.setActiveIndex}
                            style={{ color: "gainsboro" }}
                        >
                            <Icon name="user outline" />
                            Started By <Icon name="dropdown" />
                        </Accordion.Title>
                        <Accordion.Content active={activeIndex === 1}>
                            <Image
                                avatar
                                 src={
                                    currentGroup &&
                                    currentGroup.createdBy.avatar
                                }
                            />{" "}
                            {"  "}
                            {currentGroup && currentGroup.createdBy.username}
                        </Accordion.Content>
                        <Accordion.Title
                            index={2}
                            active={activeIndex === 2}
                            onClick={this.setActiveIndex}
                            style={{ color: "gainsboro" }}
                        >
                            <Icon name="chart bar outline" />
                            Top Posters <Icon name="dropdown" />
                        </Accordion.Title>
                        <Accordion.Content active={activeIndex === 2}>
                            <List>
                                {leaders && this.displayPostLeaders(leaders)}
                            </List>
                        </Accordion.Content>
                    </Accordion>
                </Segment> */}
                <Segment
                    loading={!currentGroup}
                    style={{
                        textAlign: "center",
                        background: "transparent",
                        padding: "0px"
                        // border: "1px solid transparent"
                    }}
                >
                    {/* <Header as="h4" style={{ color: "gainsboro" }}>
                        Options
                    </Header> */}
                    <Segment
                        style={{
                            textAlign: "center",
                            background: "transparent",
                            border: "1px solid transparent",
                            margin: "0",
                           
                            
                        }}
                    >

<Message    style={{background: "white", color:"black"}}
                            //    verticalAlign='middle'
                                header='Current Users'
                                content='Add Members'>
                                    
                                </Message>

 {/* <Message   icon='user md' style={{background: "white", color:"black"}}
                               verticalAlign='middle'
                                header='Current Users'
                                content='Add Members'>
                                    
                                </Message> */}


                        <Button
                        
                            inverted
                            color="blue"
                            onClick={this.openMemberModal}
                        >
                            Add Members
                        </Button>
                    </Segment>
                    {/* <Segment
                        style={{
                            textAlign: "center",
                            background: "transparent",
                            border: "1px solid transparent"
                        }}
                    >
                        <Button inverted color="teal">
                            Change Group Name
                        </Button>
                    </Segment>
                    <Segment
                        style={{
                            textAlign: "center",
                            background: "transparent",
                            border: "1px solid transparent"
                        }}
                    >
                        <Button inverted color="teal">
                            Change Group Avatar
                        </Button>
                    </Segment> */}
                </Segment>
                <Modal
                    id="member__modal"
                    size="mini"
                    open={showMemberModal}
                    onClose={this.closeMemberModal}
                >
                    <Modal.Header>
                        <Input
                            size="mini"
                            icon={<Icon name="search" inverted circular link />}
                            loading={searching}
                            fluid
                            placeholder="Find a user..."
                            onChange={this.handleSearchChange}
                            value={searchInput}
                        />
                    </Modal.Header>
                    <Modal.Content scrolling>
                        {searchInput && searchResults.length > 0
                            ? this.displaySearchResults(searchResults)
                            : "No users found"}
                    </Modal.Content>
                </Modal>
            </Fragment>
        );
    }
}

export default AddMemberGroup;
